import { render, staticRenderFns } from "./userTravel.vue?vue&type=template&id=7d1eecf1&scoped=true&"
import script from "./userTravel.vue?vue&type=script&lang=js&"
export * from "./userTravel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d1eecf1",
  null
  
)

export default component.exports